<template>
  <CustomDeleteDialog
    dialogTitle="حذف زمانبندی کار در منزل"
    :dialogId="`delete-homework-time-confirmation-dialog-${dialogId}`"
    okTitle="حذف"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendBlockRequest"
  >
    <BCol cols="12">
      آیا از حذف زمانبندی کار در منزل

      <span style="text-decoration: underline; font-weight: bold">{{
        selectedHomeworkDuration
      }}</span>
      دقیقه برای روز
      <span style="font-weight: bold">{{ selectedHomeworWeekDay }}</span>
      در تاریخ
      <span style="font-weight: bold">{{ selectedHomeworkDate }}</span>
      اطمینان دارید؟
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    selectedHomework: {
      type: Object,
    },
    dialogId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setStudentUserId(userId) {
      this.blockUserPayload.studentId = userId;
    },
    async sendBlockRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteAMasterHomework = new DeleteAMasterHomework(_this);
        deleteAMasterHomework.setRequestParam({
          input: _this.selectedHomework.id,
        });
        await deleteAMasterHomework.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "زمانبندی کار در منزل با موفقیت حذف شد.",
              },
            });
            _this.blockUserPayload = {
              masterId: null,
              studentId: null,
            };
            this.$bvModal.hide(
              `delete-homework-time-confirmation-dialog-${this.dialogId}`
            );
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    selectedHomeworkDuration() {
      if (this.selectedHomework && this.selectedHomework.masterTimeByMinute) {
        return this.selectedHomework.masterTimeByMinute;
      }
      return "";
    },
    selectedHomeworWeekDay() {
      if (this.selectedHomework && this.selectedHomework.date) {
        return this.customConvertWeekDay(this.selectedHomework.date);
      }
      return "";
    },
    selectedHomeworkDate() {
      if (this.selectedHomework && this.selectedHomework.date) {
        return this.customFullDateConvert(this.selectedHomework.date);
      }
      return "";
    },
  },
  mixins: [timeConvertUtils],
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteAMasterHomework } from "@/libs/Api/HomeWorks";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BCol } from "bootstrap-vue";
</script>
